import { SetStateAction, useState } from "react";
import { Button, Modal, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { getAllCategories } from "../../network/category";
import { PlusOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import CategorySVG from "../../assets/catalog/CategorySVG";
import AddServiceForm from "../../pages/service/add";
import { queryKeys } from "../../services/react-query/queryKeys";
import Empty from "../common/Empty";
import DownloadFileClients from "../clients/ExportModal";
import DeleteService from "../service/DeleteService";
import HeadTable from "../GlobalTable/HeadTableD";
import { css } from "@emotion/css";

import { useSelector } from "react-redux";
import ServiceItem from "./ServiceItem";
import { BsPlusSquare } from "react-icons/bs";

function ServiceTable() {
  const [clientBulkModal, setClientBulkModal] = useState(false);
  const [exportModal, setExportModal] = useState(false);
  const intl = useIntl();

  const OwnLayoutStyles = css`
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: transparent;
    font-size: 16px;
    line-height: 1.5;
    list-style: none;
    /* font-family: Cairo, sans-serif; */
    background-color: transparent;
    border: none;
    border-bottom: 0;
    border-radius: 0px;
    > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
      height: 24px;
      display: none;
      align-items: center;
      padding-inline-end: 12px;
    }
    .ant-collapse-item:last-child > .ant-collapse-content {
      border-radius: 0 0 0px 0px;
    }

    .ant-collapse {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      color: transparent;
      font-size: 16px;
      line-height: 1.5;
      list-style: none;
      /* font-family: Cairo, sans-serif; */
      background-color: transparent;
      border: none;
      border-bottom: 0;
      border-radius: 0px;
    }
    > .ant-collapse-item > .ant-collapse-header {
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      padding: 0px 0px;
      color: transparent;
      line-height: 1.5;
      cursor: pointer;
      transition: all 0.3s, visibility 0s;
    }
    .ant-collapse-content {
      color: #020418;
      background-color: #ffffff;
      border-top: none;
    }
    .mt-2 {
      margin-top: 0rem;
    }

    > .ant-collapse-item:last-child,
    > .ant-collapse-item:last-child > .ant-collapse-header {
      border-radius: 0 0 0px 0px;
    }
    > .ant-collapse-item {
      border-bottom: none;
    }
  `;

  const handleBulkCancel = () => {
    setClientBulkModal(false);
  };

  const handleExportCancel = () => {
    setExportModal(false);
  };
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState<"asc" | "desc">("desc");
  const [activeModal, setActiveModal] = useState(null);
  const [serviceData, setServiceData] = useState(null);

  const { locationId } = useSelector((state: any) => state?.calendar);
  const { data: servicesData, isLoading } = useQuery(
    [queryKeys.listCategories, locationId, search],
    () =>
      getAllCategories({
        "location_ids[0]": locationId,
        with_location_services: locationId,
        with_parent: 1,
        search: search,
      }),
    {
      enabled: !!locationId,
      select: (res) => {
        const data: any[] = [];
        res?.data?.map((category: { services: any[] }) => {
          if (category?.services?.length > 0) {
            const categoryData = {
              ...category,
              services: category?.services?.sort((a: any, b: any) => {
                if (sort === "desc") {
                  return (
                    new Date(a?.updated_at).getTime() -
                    new Date(b?.updated_at).getTime()
                  );
                } else {
                  return (
                    new Date(b?.updated_at).getTime() -
                    new Date(a?.updated_at).getTime()
                  );
                }
              }),
            };
            data.push(categoryData);
          }
        });
        return data;
      },
    }
  );

  const openModal = (modal: any) => {
    setActiveModal(modal);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const modalComponents = {
    DELETESERVICE: (
      <DeleteService
        visible={true}
        onClose={closeModal}
        editServiceData={serviceData}
      />
    ),
    SERVICE: <AddServiceForm visible={true} onClose={closeModal} />,
    EditSERVICE: (
      <AddServiceForm
        visible={true}
        onClose={closeModal}
        editServiceData={serviceData}
      />
    ),
  };

  const renderModal = activeModal ? modalComponents[activeModal] : null;

  const openModalEdit = (modal: any, data: any) => {
    setActiveModal(modal);
    setServiceData(data);
  };

  return (
    <div className="tabs p-6 bg-[#eef0ff]">
      {renderModal}
      <Modal
        width="60%"
        centered
        open={exportModal}
        onCancel={handleExportCancel}
        footer={null}
      >
        <DownloadFileClients close={handleBulkCancel} />
      </Modal>
      <HeadTable
        search={search}
        setSearch={setSearch}
        sort={sort}
        setSort={setSort}
        placeHolderSerch={intl.formatMessage({
          id: "services_tab_placeholder",
        })}
        button={
          <Button
            onClick={() => {
              openModal("SERVICE");
            }}
            icon={<BsPlusSquare />}
            type="primary"
            className=""
          >
            {intl.formatMessage({ id: "add_service_label" })}
          </Button>
        }
        data={undefined}
        deleteModal={undefined}
        setDeleteModal={function (value: SetStateAction<boolean>): void {
          throw new Error("Function not implemented.");
        }}
      />

      <Spin size="large" spinning={isLoading} className="">
        {servicesData && servicesData?.length > 0 ? (
          <div className="space-y-4 ">
            {servicesData?.map(
              (category: {
                name: string;
                id: number;
                services?: any;
                packages: any;
              }) => (
                <div key={category?.id} className="">
                  <div className="flex gap-2">
                    <CategorySVG />
                    <p>{category?.name}</p>
                  </div>

                  {category?.services?.length > 0 &&
                    category?.services?.map((serviceItem: any) => (
                      <ServiceItem
                        serviceItem={serviceItem}
                        OwnLayoutStyles={OwnLayoutStyles}
                        openModalEdit={openModalEdit}
                        key={serviceItem?.id}
                      />
                    ))}
                </div>
              )
            )}
          </div>
        ) : !isLoading && servicesData && servicesData?.length === 0 ? (
          <Empty
            title={intl.formatMessage({ id: "empty_title" })}
            subTitle={intl.formatMessage({ id: "empty_subTitle" })}
            buttons={
              <div>
                <Button
                  onClick={() => openModal("SERVICE")}
                  className="border-none bg-[#EEF0FF] shadow-none outline-none text-[#75757E]"
                  icon={<PlusOutlined />}
                >
                  {intl.formatMessage({ id: "add_service_label" })}
                </Button>
              </div>
            }
          />
        ) : (
          <div className="min-h-[300px]"></div>
        )}
      </Spin>
    </div>
  );
}

export default ServiceTable;
